{
  "title": "Investiture of Ice",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "6th-level transmutation",
  "level": 6,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Until the spell ends, ice rimes your body, and you gain the following benefits:",
    "You are immune to cold damage and have resistance to fire damage.",
    "You can move across difficult terrain created by ice or snow without spending extra movement.",
    "The ground in a 10-foot radius around you is icy and is difficult terrain for creatures other than you. The radius moves with you.",
    "You can use your action to create a 15-foot cone of freezing wind extending from your outstretched hand in a direction you choose. Each creature in the cone must make a Constitution saving throw. A creature takes 4d6 cold damage on a failed save, or half as much damage on a successful one. A creature that fails its save against this effect has its speed halved until the start of your next turn."
  ],
  "spellLists": ["druid", "sorcerer", "warlock", "wizard"]
}
